import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Homeowner',
      image: 'https://public.readdy.ai/ai/img_res/d8d6c81d7639c7258ed137280d466957.jpg',
      rating: 5,
      text: 'Absolutely amazing service! The team was professional, thorough, and left my home sparkling clean. I\'ve been using their services for over a year now and couldn\'t be happier. Highly recommend!'
    },
    {
      name: 'Michael Chen',
      role: 'Business Owner',
      image: 'https://readdy.ai/api/search-image?query=professional%20man%20smiling%20portrait%20satisfied%20client%20office%20background%20natural%20lighting%20confident%20friendly%20business%20casual%20attire%20modern%20setting&width=400&height=400&seq=testimonial-002&orientation=squarish',
      rating: 5,
      text: 'We use their office cleaning services and the difference is remarkable. Our workspace is always pristine, and the staff is incredibly reliable. Great value for the quality of service provided.'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Working Mom',
      image: 'https://readdy.ai/api/search-image?query=young%20woman%20smiling%20portrait%20happy%20mother%20home%20interior%20background%20warm%20lighting%20genuine%20smile%20casual%20comfortable%20style%20welcoming%20atmosphere&width=400&height=400&seq=testimonial-003&orientation=squarish',
      rating: 5,
      text: 'As a busy mom of three, this service has been a lifesaver! The cleaners are trustworthy, efficient, and always go above and beyond. My house has never looked better, and I finally have time for my family.'
    },
    {
      name: 'David Thompson',
      role: 'Retiree',
      image: 'https://readdy.ai/api/search-image?query=senior%20man%20smiling%20portrait%20happy%20elderly%20gentleman%20home%20background%20natural%20lighting%20friendly%20warm%20expression%20comfortable%20setting%20trustworthy&width=400&height=400&seq=testimonial-004&orientation=squarish',
      rating: 5,
      text: 'I\'ve tried several cleaning services over the years, but this one stands out. They pay attention to detail and treat my home with respect. The booking process is easy, and they\'re always on time.'
    },
    {
      name: 'Jennifer Martinez',
      role: 'Real Estate Agent',
      image: 'https://readdy.ai/api/search-image?query=professional%20businesswoman%20smiling%20portrait%20confident%20real%20estate%20agent%20modern%20office%20background%20natural%20lighting%20professional%20attire%20friendly%20approachable&width=400&height=400&seq=testimonial-005&orientation=squarish',
      rating: 5,
      text: 'I recommend this cleaning service to all my clients for move-in/move-out cleaning. They consistently deliver exceptional results and make the transition process so much smoother. True professionals!'
    },
    {
      name: 'Robert Williams',
      role: 'Homeowner',
      image: 'https://readdy.ai/api/search-image?query=middle%20aged%20man%20smiling%20portrait%20satisfied%20homeowner%20residential%20background%20natural%20lighting%20genuine%20smile%20casual%20style%20comfortable%20home%20setting&width=400&height=400&seq=testimonial-006&orientation=squarish',
      rating: 5,
      text: 'Outstanding service from start to finish! The deep cleaning they did before we moved in was incredible. Every surface was spotless. We now use them for regular maintenance and couldn\'t be more satisfied.'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about our cleaning services.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8">
              <div className="flex-shrink-0">
                <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden shadow-lg">
                  <img 
                    src={testimonials[activeIndex].image}
                    alt={testimonials[activeIndex].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1 text-center md:text-left">
                <div className="flex justify-center md:justify-start mb-3 sm:mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg sm:text-xl"></i>
                  ))}
                </div>
                <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 leading-relaxed italic">
                  "{testimonials[activeIndex].text}"
                </p>
                <div>
                  <div className="font-bold text-gray-900 text-base sm:text-lg">
                    {testimonials[activeIndex].name}
                  </div>
                  <div className="text-sm text-gray-600">
                    {testimonials[activeIndex].role}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button 
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 sm:-translate-x-6 md:-translate-x-12 w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl sm:text-2xl text-gray-700"></i>
          </button>
          <button 
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 sm:translate-x-6 md:translate-x-12 w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl sm:text-2xl text-gray-700"></i>
          </button>

          <div className="flex justify-center gap-2 mt-6 sm:mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                  index === activeIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}